<script>
import Swal from "sweetalert2";
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";
import Switches from "vue-switches";
export default {
    components: {
        Switches
    },
    data() {
        return {
            submitted: false,
            tableData: [],
            modalTitle: "",
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "name",
            sortDesc: false,
            fields: [
                {
                    key: "name",
                    sortable: true,
                },
                {
                    key: "type",
                    sortable: true,
                },
                {
                    key: "items",
                    sortable: false,
                    label: 'Members'
                },
                {
                    key: "secretary",
                    sortable: false,
                    label: 'Secretary'
                },
                {
                    key: "actions",
                    thStyle: { width: "90px" },
                },
            ],
            form: {
                id: 0,
                name: null,
                type: null,
                description: null,
                campusId: null,
                bacSecretaryApplicationUserId: null,
                contactNumber: null,
                address: null,
                email: null
            },
            member: {
                id: 0,
                bacSettingId: 0,
                applicationUserId: null,
                position: null,
                name: null,
                isActive: false,
                isChairman: false,
            },
            indexSelected: -1,
            memberIndex: -1,
            tableBusy: false,
            selectedBAC: {},
            memberName: '',
        };
    },
    computed: {
        rows() {
            if (this.filter) {
                return this.totalRows;
            }
            return this.tableData.length;
        },
    },
    validations: {
        form: {
            name: { required },
            type: { required },
            description: { required },
        },
        member: {
            applicationUserId: {required},
            position: {required},
        },
    },
    methods: {
        async getItems() {
            const wait = (delay, ...args) =>new Promise((resolve) =>setTimeout(resolve, delay, ...args));
            this.$store.dispatch('data/mutateGlobalStop', false);
            for await(const item of this.tableData){
                if(this.$store.state.data.globalStop){
                    break;
                }
                if(item.items.length == 0){
                    await this.$store
                        .dispatch("bacsetting/GetBacMemberAll", item.id)
                        .then((res) => {
                            if(res.data.error){
                                return  this.showToast("Something went wrong!", "error");
                            }
                            item.items = res.data;
                            item.itemLoading = false;
                        })
                        .catch(() => {
                            item.itemLoading = false;
                            this.showToast("Something went wrong!", "error");
                        });
                    await wait(1000);
                }
            }
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        addSettings() {
            this.onReset();
            this.modalTitle = "Create New Bac Setting";
            this.$bvModal.show("setting-modal");
        },
        onReset() {
            this.form = {
                id: 0,
                name: "",
                type: "",
                description: "",
                campusId: this.$store.state.data.selectedCampus.id,
                bacSecretaryApplicationUserId: null,
                contactNumber: null,
                address: null,
                email: null
            };
        },
        onCreate() {
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                return;
            } else {
                this.form.campusId = this.$store.state.data.selectedCampus.id;
                if (this.form.id > 0) {
                    this.$store
                        .dispatch("bacsetting/UpdateBacSetting", this.form)
                        .then((res) => {
                            this.tableData.splice(
                                this.indexSelected,
                                1,
                                this.form
                            );
                            this.$bvModal.hide("setting-modal");
                            this.showToast("Successfully updated!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                } else {
                    this.$store
                        .dispatch("bacsetting/CreateBacSetting", this.form)
                        .then((res) => {
                            res.data.items = [];
                            res.data.itemLoading = false;
                            this.tableData.push(res.data);
                            this.$bvModal.hide("setting-modal");
                            this.showToast("Successfully created!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
                this.submitted = false;
            }
        },
        updateItem(props) {
            this.form = cloneDeep(props.item);
            this.indexSelected = this.tableData.indexOf(props.item);
            this.modalTitle = "Update BAC Settings";
            this.$bvModal.show("setting-modal");
        },
        deleteItem(props) {
            var index = this.tableData.indexOf(props.item);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch(
                            "bacsetting/DeleteBacSetting",
                            props.item.id
                        )
                        .then((res) => {
                            if (res.status == 204) {
                                this.tableData.splice(index, 1);
                                this.showToast(
                                    "Successfully deleted!",
                                    "success"
                                );
                            }
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        addItems(props) {
            this.selectedBAC = props;
            this.onResetMember(props);
            this.modalTitle = "Add Member";
            this.$bvModal.show("add-member-modal");
        },
        onResetMember(props) {
            this.member = {
                id: 0,
                bacSettingId: props.id,
                applicationUserId: "",
                position: "",
                name: "",
                isActive: true,
                isChairman: false,
            };
        },
        onCreateMember() {
            this.submitted = true;
            this.$v.member.$touch();
            if (this.$v.member.$invalid) {
                return;
            } 
            var data = cloneDeep(this.member);
            if (this.member.id > 0) {
                this.$store
                    .dispatch("bacsetting/UpdateBacMember", data)
                    .then((res) => {
                        if(res.data.error){
                            this.showToast(res.data.errorMessage, 'error');
                        }
                        this.selectedBAC.items.splice(this.memberIndex, 1, data);
                        this.$bvModal.hide("add-member-modal");
                        this.showToast("Successfully updated!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            } else {
                this.$store
                    .dispatch("bacsetting/CreateBacMember", data)
                    .then((res) => {
                        if(res.data.error){
                            this.showToast(res.data.errorMessage, 'error');
                        }
                        this.selectedBAC.items.push(res.data);
                        console.log(this.selectedBAC.items)
                        this.$bvModal.hide("add-member-modal");
                        this.showToast("Successfully created!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
            this.submitted = false;
        },
        getSettings(campusId, force = false) {
            if(this.tableData.length == 0 || force){
                this.tableBusy = true;
                this.$store
                .dispatch(
                    "bacsetting/GetBacSetting",
                    campusId
                )
                .then((res) => {
                    res.data.map((item) => {
                        item.items = [];
                        item.itemLoading = true;
                    });
                    this.tableData = res.data;
                    this.tableBusy = false;
                    this.getItems();
                })
                .catch(() => {
                    this.tableBusy = false;
                    this.showToast("Something went wrong!", "error");
                });
            }else{
                this.getItems();
            }
        },
        removeFromList(props, row){
            var index = row.items.indexOf(props);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch(
                            "bacsetting/DeleteBacMember",
                            props.id
                        )
                        .then((res) => {
                            if (res.status == 204) {
                                row.items.splice(index, 1);
                                this.showToast(
                                    "Successfully deleted!",
                                    "success"
                                );
                            }
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        selectEmployee(){
            this.$emit('callToOpen', {from: 'BAC'})
        },
        selectSecretary(){
            this.$emit('callToOpen', {from: 'Secretary'})
        },
        selectedEmployee(employee, from){
            if(from === 'BAC'){
                this.memberName = employee.applicationUser.completeName;
                this.member.applicationUserId =  employee.applicationUser.id;
                this.member.applicationUser = employee.applicationUser;
            }else{
                this.form.bacSecretaryApplicationUserId = employee.applicationUser.id;
                this.form.bacSecretary = employee.applicationUser.completeName;
            }
        },
        updateFromList(props, row){
            this.selectedBAC = row;
            this.memberIndex = row.items.indexOf(props);
            this.member = cloneDeep(props);
            this.memberName = props.employee;
            this.modalTitle = "Update Member";
            this.$bvModal.show("add-member-modal");
        },
        checkList(data){
            this.$store
                .dispatch("bacsetting/UpdateBacMember", data)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                })
                .catch((err) => {
                    this.showToast('Something went wrong', "error");
                });
        },
        changePosition(){
            if(this.member.position == 'CHAIRPERSON'){
                this.member.isChairman = true;
            }else{
                this.member.isChairman = false;
            }
        }
    },
};
</script>

<template>
    <div>
        <!-- <employee-modal ref="empModal" @dropMultiple="saveEmployeeCategories"></employee-modal> -->
        <b-modal
            id="setting-modal"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <form
                @submit.prevent="onCreate"
                class="needs-validation"
                ref="slForm"
            >
                <div class="mb-3">
                    <label for="name">BAC Name </label>
                    <input
                        autocomplete="off"
                        id="name"
                        type="text"
                        v-model="form.name"
                        placeholder="Enter BAC Name..."
                        class="form-control"
                        :class="{
                            'is-invalid': submitted && $v.form.name.$error,
                        }"
                    />
                    <div
                        v-if="submitted && $v.form.name.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.form.name.required"
                            >This value is required.</span
                        >
                    </div>
                </div>
                <div class="mb-3">
                    <label for="name">BAC Type </label>
                    <input
                        autocomplete="off"
                        id="type"
                        type="text"
                        v-model="form.type"
                        placeholder="Enter BAC Type..."
                        class="form-control"
                        :class="{
                            'is-invalid': submitted && $v.form.type.$error,
                        }"
                    />
                    <div
                        v-if="submitted && $v.form.type.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.form.type.required"
                            >This value is required.</span
                        >
                    </div>
                </div>
                <div class="mb-3">
                    <label for="description">Description </label>
                    <input
                        autocomplete="off"
                        id="description"
                        type="text"
                        v-model="form.description"
                        placeholder="Enter Description..."
                        class="form-control"
                        :class="{
                            'is-invalid':
                                submitted && $v.form.description.$error,
                        }"
                    />
                    <div
                        v-if="submitted && $v.form.description.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.form.description.required"
                            >This value is required.</span
                        >
                    </div>
                </div>
                <div class="mb-3">
                    <label for="name">BAC Secretary </label>
                    <b-input-group>
                        <template
                            #append
                        >
                            <b-button
                                @click="selectSecretary"
                                variant="outline-info"
                                ><i
                                    class="
                                        mdi
                                        mdi-clipboard-text-search-outline
                                    "
                                ></i
                            ></b-button>
                        </template>
                        <input
                            id="name"
                            type="text"
                            v-model="form.bacSecretary"
                            placeholder="Select Secretary..."
                            class="form-control"
                            disabled
                        />
                    </b-input-group>
                </div>
                <template v-if="form.bacSecretaryApplicationUserId">
                    <div class="mb-3">
                        <label for="description">Contact Number </label>
                        <input
                            autocomplete="off"
                            id="description"
                            type="text"
                            v-model="form.contactNumber"
                            placeholder="Enter Contact Number..."
                            class="form-control"
                        />
                    </div>
                    <div class="mb-3">
                        <label for="description">Address</label>
                        <input
                            autocomplete="off"
                            id="description"
                            type="text"
                            v-model="form.address"
                            placeholder="Enter Address..."
                            class="form-control"
                        />
                    </div>
                    <div class="mb-3">
                        <label for="description">Email</label>
                        <input
                            autocomplete="off"
                            id="description"
                            type="text"
                            v-model="form.email"
                            placeholder="Enter Email..."
                            class="form-control"
                        />
                    </div>
                </template>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Save changes
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('setting-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <b-modal
            id="add-member-modal"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <form
                @submit.prevent="onCreateMember"
                class="needs-validation"
                ref="memForm"
            >
                <div class="mb-3">
                    <label for="name">Employee </label>
                    <b-input-group>
                        <template
                            #append
                        >
                            <b-button
                                @click="selectEmployee"
                                variant="outline-info"
                                ><i
                                    class="
                                        mdi
                                        mdi-clipboard-text-search-outline
                                    "
                                ></i
                            ></b-button>
                        </template>
                        <input
                            id="name"
                            type="text"
                            v-model="memberName"
                            placeholder="Select Member Name..."
                            class="form-control"
                            :class="{
                                'is-invalid': submitted && $v.member.applicationUserId.$error,
                            }"
                            disabled
                        />
                    </b-input-group>
                    <div
                        v-if="submitted && $v.member.applicationUserId.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.member.applicationUserId.required"
                            >This value is required.</span
                        >
                    </div>
                </div>
                <div class="mb-3">
                    <label for="name">Position </label>
                    <select name="position" class="form-select" v-model="member.position" 
                        :class="{
                            'is-invalid': submitted && $v.member.position.$error,
                        }"
                        @change="changePosition"
                    >
                        <option></option>
                        <option>CHAIRPERSON</option>
                        <option>VICE CHAIRPERSON</option>
                        <option>REGULAR MEMBER</option>
                        <option>CAMPUS HEAD</option>
                        <option>PROVISIONAL MEMBERS</option>
                        <option>TECHNICAL REVIEWER</option>
                    </select>
                    <div
                        v-if="submitted && $v.member.position.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.member.position.required"
                            >This value is required.</span
                        >
                    </div>
                </div>
                <div class="mb-3" v-if="member.position == 'CAMPUS HEAD'">
                    <label for="name">Position Title </label>
                    <input
                        autocomplete="off"
                        id="name"
                        type="text"
                        v-model="member.title"
                        placeholder="Input Position Title..."
                        class="form-control"
                    />
                </div>
                <div class="d-flex align-items-center mb-2">
                    <div class="d-flex align-items-center me-5">
                        <switches
                            v-model="member.isActive"
                            id="isActive"
                            color="success"
                            class="mb-0"
                        ></switches>
                        <label for="isActive" class="mx-2 my-0">
                            <span>{{member.isActive ? 'Active' : 'Inactive'}}</span>
                        </label>
                    </div>
                    <!-- <div>
                        <div
                            class="
                                form-check
                                form-checkbox-outline
                                form-check-success
                                mb-0
                            "
                        >
                            <input
                                type="checkbox"
                                :id="`customCheckcolor-chairman`"
                                class="form-check-input"
                                v-model="member.isChairman"
                            />
                            <label
                                :for="`customCheckcolor-chairman`"
                                class="form-check-label no-wrap"
                            >
                                Is Chairman?
                            </label>
                        </div>
                    </div> -->
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Save changes
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('add-member-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <div class="row">
            <div class="col-12">
                <div class="card border">
                    <div class="card-body">
                        <div
                            class="
                                d-flex
                                justify-content-between
                                align-items-center
                            "
                        >
                            <h4 class="card-title m-0">BAC Setting List</h4>
                            <button
                                type="button"
                                @click="addSettings()"
                                class="
                                    btn btn-md btn-info
                                    d-flex
                                    align-items-center
                                "
                            >
                                <i class="bx bx-plus fs-6"></i>Create New
                            </button>
                        </div>
                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-6">
                                <div
                                    id="tickets-table_length"
                                    class="dataTables_length"
                                >
                                    <label
                                        class="d-inline-flex align-items-center"
                                    >
                                        Show&nbsp;
                                        <b-form-select
                                            class="form-select form-select-sm"
                                            v-model="perPage"
                                            size="sm"
                                            :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div
                                    id="tickets-table_filter"
                                    class="dataTables_filter text-md-end"
                                >
                                    <label
                                        class="d-inline-flex align-items-center"
                                    >
                                        Search:
                                        <b-form-input
                                            autocomplete="off"
                                            v-model="filter"
                                            type="search"
                                            placeholder="Search..."
                                            class="
                                                form-control form-control-sm
                                                ms-2
                                            "
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <div class="table-responsive mb-0">
                            <b-table
                                class="datatables"
                                :items="tableData"
                                :fields="fields"
                                responsive="sm"
                                :per-page="perPage"
                                :current-page="currentPage"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :filter="filter"
                                :filter-included-fields="filterOn"
                                :busy="tableBusy"
                                @filtered="onFiltered"
                                bordered
                                outlined
                                hover
                                striped
                                show-empty
                            >
                                <template #empty="scope">
                                    <div class="text-center">
                                        {{ scope.emptyText }}
                                    </div>
                                </template>
                                <template #table-busy>
                                    <div
                                        class="
                                            d-flex
                                            justify-content-center
                                            align-items-center
                                        "
                                    >
                                        <div class="preloader-component me-2">
                                            <div class="status">
                                                <div
                                                    class="
                                                        spinner-chase
                                                        w-20px
                                                        h-20px
                                                    "
                                                >
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                </div>
                                            </div>
                                        </div>
                                        <strong>Loading...</strong>
                                    </div>
                                </template>
                                <template #cell(name)="row">
                                    {{row.value}}
                                    <div>
                                        <small>{{row.item.description}}</small>
                                    </div>
                                </template>
                                <template #row-details="row">
                                    <div class="p-0"> 
                                        <div class="text-right"><a href="javascript:void(0);" @click="row.toggleDetails()">Hide Details</a></div>
                                        <div class="table-responsive">
                                            <table
                                                class="
                                                    table table-centered
                                                    align-middle
                                                    project-list-table
                                                    border-collapse-none
                                                "
                                            >
                                                <tbody>
                                                    <tr v-for="x in row.item.items" :key="x.id">
                                                        <td>
                                                            <div class="d-flex justify-content-between align-items-center">
                                                                <div
                                                                    class="
                                                                        d-flex
                                                                        align-items-center
                                                                    "
                                                                >
                                                                    <div>
                                                                        <div class="text-white d-flex">
                                                                            <p class="mb-0">{{ x.employee }}</p>
                                                                            <div class="ms-3 d-flex">(
                                                                                <div class="form-check form-checkbox-outline form-check-success mb-0">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        :id="`email-${x.id}`"
                                                                                        class="form-check-input"
                                                                                        v-model="x.receiveEmail"
                                                                                        @change="checkList(x)"
                                                                                    />
                                                                                    <label
                                                                                        :for="`email-${x.id}`"
                                                                                        class="form-check-label no-wrap"
                                                                                    >
                                                                                        Email
                                                                                    </label>
                                                                                </div>
                                                                                <div class="form-check form-checkbox-outline form-check-success mb-0 ms-2">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        :id="`sms-${x.id}`"
                                                                                        class="form-check-input"
                                                                                        v-model="x.receiveSMS"
                                                                                        @change="checkList(x)"
                                                                                    />
                                                                                    <label
                                                                                        :for="`sms-${x.id}`"
                                                                                        class="form-check-label no-wrap"
                                                                                    >
                                                                                        SMS
                                                                                    </label>
                                                                                </div>
                                                                            )</div>
                                                                        </div>
                                                                        <div>
                                                                            <small>
                                                                            {{
                                                                                x.position
                                                                            }} <span class="text-green" v-if="x.isChairman"><b>[Chairman]</b></span>
                                                                            </small>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td style="width:50px;">
                                                            <div class="d-flex align-items-center justify-content-center">
                                                                <i class="bx bx-edit font-size-18 text-primary cursor-pointer" title="Update Member" @click="updateFromList(x, row.item)"></i>
                                                            </div>
                                                        </td>
                                                        <td style="width:50px;">
                                                            <div class="d-flex align-items-center justify-content-center">
                                                                <i class="bx bx-trash font-size-18 text-danger cursor-pointer" title="Remove from List" @click="removeFromList(x, row.item)"></i>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </template>
                                <template #cell(items)="row">
                                    <div v-if="row.item.itemLoading">
                                        <div
                                            class="
                                                d-flex
                                                justify-content-center
                                                align-items-center
                                            "
                                        >
                                            <div
                                                class="preloader-component me-2"
                                            >
                                                <div class="status">
                                                    <div
                                                        class="
                                                            spinner-chase
                                                            w-20px
                                                            h-20px
                                                        "
                                                    >
                                                        <div
                                                            class="chase-dot"
                                                        ></div>
                                                        <div
                                                            class="chase-dot"
                                                        ></div>
                                                        <div
                                                            class="chase-dot"
                                                        ></div>
                                                        <div
                                                            class="chase-dot"
                                                        ></div>
                                                        <div
                                                            class="chase-dot"
                                                        ></div>
                                                        <div
                                                            class="chase-dot"
                                                        ></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <strong>Loading...</strong>
                                        </div>
                                    </div>
                                    <div
                                        class="avatar-group"
                                        v-if="
                                            row.item.items.length > 0 &&
                                            !row.item.itemLoading
                                        "
                                        @click="row.toggleDetails()"
                                    >
                                        <div class="avatar-group-item">
                                            <a
                                                href="javascript: void(0);"
                                                class="d-inline-block"
                                                >
                                                <span
                                                    class="
                                                        rounded-circle
                                                        avatar-xs
                                                        d-flex
                                                        align-items-center
                                                        justify-content-center
                                                        bg-gradient bg-primary
                                                        text-white
                                                        border-avatar
                                                    "
                                                    :title="
                                                        row.item.items[0].employee
                                                    "
                                                    >{{ row.item.items[0].employee.charAt(0) }}</span
                                                >
                                            </a>
                                        </div>
                                        <div
                                            class="avatar-group-item"
                                            v-if="row.item.items.length > 1"
                                        >
                                            <a
                                                href="javascript: void(0);"
                                                class="d-inline-block"
                                                >
                                                <span
                                                    class="
                                                        rounded-circle
                                                        avatar-xs
                                                        d-flex
                                                        align-items-center
                                                        justify-content-center
                                                        bg-success bg-gradient
                                                        text-white
                                                        border-avatar
                                                    "
                                                    :title="row.item.items[1].employee"
                                                    >{{ row.item.items[1].employee.charAt(0) }}</span
                                                >
                                            </a>
                                        </div>
                                        <div
                                            class="avatar-group-item"
                                            v-if="row.item.items.length > 2"
                                        >
                                            <a
                                                href="javascript: void(0);"
                                                class="d-inline-block"
                                                >
                                                <span
                                                    class="
                                                        rounded-circle
                                                        avatar-xs
                                                        d-flex
                                                        align-items-center
                                                        justify-content-center
                                                        bg-warning bg-gradient
                                                        text-white
                                                        border-avatar
                                                    "
                                                    :title="
                                                        row.item.items[2].employee
                                                    "
                                                    >{{
                                                        row.item.items[2].employee.charAt(
                                                            0
                                                        )
                                                    }}</span
                                                >
                                            </a>
                                        </div>
                                        <div
                                            class="avatar-group-item"
                                            v-if="row.item.items.length > 3"
                                        >
                                            <a
                                                href="javascript: void(0);"
                                                class="d-inline-block"
                                                >
                                                <span
                                                    class="
                                                        rounded-circle
                                                        avatar-xs
                                                        d-flex
                                                        align-items-center
                                                        justify-content-center
                                                        bg-danger bg-gradient
                                                        text-white
                                                        border-avatar
                                                    "
                                                    :title="row.item.items[3].employee"
                                                    >{{ row.item.items[3].employee.charAt(0) }}</span
                                                >
                                            </a>
                                        </div>
                                        <div
                                            class="avatar-group-item"
                                            v-if="row.item.items.length > 4"
                                        >
                                            <a
                                                href="javascript: void(0);"
                                                class="d-inline-block"
                                            >
                                               
                                                <span
                                                    class="
                                                        rounded-circle
                                                        avatar-xs
                                                        d-flex
                                                        align-items-center
                                                        justify-content-center
                                                        bg-white
                                                        border-avatar
                                                    "
                                                    :title="
                                                        row.item.items[4].employee
                                                    "
                                                    >{{
                                                        row.item.items[4].employee.charAt(
                                                            0
                                                        )
                                                    }}</span
                                                >
                                            </a>
                                        </div>
                                        <div
                                            class="avatar-group-item"
                                            v-if="row.item.items.length > 5"
                                        >
                                            <span
                                                class="
                                                    rounded-circle
                                                    avatar-xs
                                                    d-flex
                                                    align-items-center
                                                    justify-content-center
                                                    bg-white
                                                    border-avatar
                                                "
                                                >+{{
                                                    row.item.items.length - 5
                                                }}</span
                                            >
                                        </div>
                                    </div>
                                    <a
                                        href="javascript:void(0);"
                                        class="text-success"
                                        v-if="!row.item.itemLoading"
                                        @click="addItems(row.item)"
                                        ><i class="bx bx-plus"></i
                                        >{{
                                            row.item.items.length > 0
                                                ? "Add More Members"
                                                : "Add Members"
                                        }}</a
                                    >
                                </template>
                                <template #cell(actions)="row">
                                    <div class="float-end">
                                        <b-dropdown
                                            id="dropdown-dropleft"
                                            right
                                            variant="link"
                                            toggle-class="text-decoration-none"
                                            menu-class="dropdown-menu-end"
                                            no-caret
                                        >
                                            <template #button-content>
                                                <i
                                                    class="fas fa-ellipsis-v"
                                                ></i>
                                            </template>
                                            <b-dropdown-item
                                                @click="updateItem(row)"
                                                variant="secondary"
                                                ><i
                                                    class="
                                                        mdi mdi-update
                                                        font-size-18
                                                        me-1
                                                    "
                                                ></i
                                                >Edit</b-dropdown-item
                                            >
                                            <b-dropdown-item
                                                @click="deleteItem(row)"
                                                variant="danger"
                                                ><i
                                                    class="
                                                        mdi mdi-trash-can
                                                        font-size-18
                                                        me-1
                                                    "
                                                ></i
                                                >Delete</b-dropdown-item
                                            >
                                        </b-dropdown>
                                    </div>
                                </template>
                                <template #cell(secretary)="row">
                                    <div>
                                        <p class="mb-0">{{row.item.bacSecretary}}</p>
                                        <ul v-if="row.item.bacSecretary">
                                            <li>{{row.item.contactNumber}}</li>
                                            <li>{{row.item.address}}</li>
                                            <li>{{row.item.email}}</li>
                                        </ul>
                                    </div>
                                    
                                </template>
                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div
                                    class="
                                        dataTables_paginate
                                        paging_simple_numbers
                                        float-end
                                    "
                                >
                                    <ul
                                        class="
                                            pagination pagination-rounded
                                            mb-0
                                        "
                                    >
                                        <!-- pagination -->
                                        <b-pagination
                                            v-model="currentPage"
                                            :total-rows="rows"
                                            :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>